function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.79997 16.89L15.57 12.82C16.13 12.42 16.13 11.58 15.57 11.19L9.79997 7.11002C9.12997 6.65002 8.21997 7.12002 8.21997 7.93002V16.07C8.21997 16.88 9.12997 17.35 9.79997 16.89Z",
    fill: "#9da3a8"
  }));
};
export default SvgComponent;
//# sourceMappingURL=next.js.map